import { render, staticRenderFns } from "./AppCertificates.vue?vue&type=template&id=b014d9d0"
import script from "./AppCertificates.vue?vue&type=script&lang=js"
export * from "./AppCertificates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports